import { Component } from "react";
import Footer from "../Footer";
import AutoHideableHeader from "../HeaderComponents/AutoHideableHeader";
import RimiLogoHeaderButton from "../HeaderComponents/RimiLogoHeaderButton";
import StepBackHeader from "../HeaderComponents/StepBackHeader";
import FetcherApi from "../FetcherApi";
import TranslationText from "../Translation/TranslationText";
import InputText from "../InputText";
import { TemporarySuccessDisplay } from "../SuccessDisplay/TemporarySuccessDisplay";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Trans, withTranslation } from "react-i18next";
import { NavLink } from "react-bootstrap";
import ConsentLinks from "../Consents/ConsentLinks";

class VerificationCodeLayout extends Component {
	getActivationCodeFormField() {
		const {
			error,
			codeAttemptsLeft,
			activationCode,
			onChange,
			isResendSuccessDisplayed,
			onResendSuccessDisplayExpiration
		} = this.props;

		return (
			<div className={`form-field ${error ? '-has-error' : ''}`}>
				<label className="form-field__label" htmlFor="activation_code">
					<TranslationText
						text={codeAttemptsLeft > 0 ? "verification_code_page_code_field_attempts_left_title" : "verification_code_page_code_field_title"}
						options={{ attemptsLeft: codeAttemptsLeft }}
					/>
				</label>
				<div className="verification-code">
					<InputText
						className="form-field__input"
						name="field-1"
						type="tel"
						min="0"
						max="9"
						isSelectedOnFocus={true}
						prop="code1"
						value={activationCode.code1}
						onChange={onChange}
					/>
					<InputText
						className="form-field__input"
						name="field-2"
						type="tel"
						min="0"
						max="9"
						isSelectedOnFocus={true}
						prop="code2"
						value={activationCode.code2}
						onChange={onChange}
					/>
					<InputText
						className="form-field__input"
						name="field-3"
						type="tel"
						min="0"
						max="9"
						isSelectedOnFocus={true}
						prop="code3"
						value={activationCode.code3}
						onChange={onChange}
					/>
					<InputText
						className="form-field__input"
						name="field-4"
						type="tel"
						min="0"
						max="9"
						isSelectedOnFocus={true}
						prop="code4"
						value={activationCode.code4}
						onChange={onChange}
					/>
				</div>
				<div className="message-container">
					<TemporarySuccessDisplay
						message="verification_code_page_resend_success_message"
						isDisplayed={isResendSuccessDisplayed}
						onExpiration={onResendSuccessDisplayExpiration}
					/>
					{
						error ? (
							<div className="form-row">
								<div className="sublabel error-msg show">
									<span>
										<TranslationText text={error} />
									</span>
								</div>
							</div>
						) : null
					}
				</div>
			</div>
		);
	}

	render() {
		const {
			initialData,
			previousPath,
			header,
			hideCodeEntryControls,
			onConfirm,
			isConfirmDisabled,
			hasAttempted,
			infoText,
			infoTextValues,
			resendText,
			onResend,
			onSecondaryButtonClick
		} = this.props;

		const secondaryButtonText = this.props.secondaryButtonText ?? "return_to_login_page";
		const secondaryButtonLinkTo = this.props.secondaryButtonLinkTo ?? "/login";

		return (
			<>
				<div className="container">
					<div className="card">
						<AutoHideableHeader>
							<RimiLogoHeaderButton initialData={initialData} />
							<StepBackHeader
								handleClick={_ => FetcherApi.resetHandshakeToken()}
								buttonText="step_back_button_label"
								pathName={previousPath}
							/>
						</AutoHideableHeader>
						<div className="card-content verification-code-card">
							<h1>
								<TranslationText text={header} />
							</h1>
							{
								!hideCodeEntryControls ? (
									<div className="form-group">
										<div className="form-row">
											{this.getActivationCodeFormField()}
										</div>
										<div className="form-button full-width">
											<button
												type="submit"
												className="button"
												disabled={isConfirmDisabled}
												onClick={onConfirm}
											>
												<TranslationText text={hasAttempted ? "try_again_button_label" : "confirm_button_label"} />
											</button>
										</div>
									</div>
								) : (
									<div className="form-row">
										<div className="sublabel error-msg show">
											<span>
												<TranslationText text="verification_code_page_retry_limit_error" />
											</span>
										</div>
									</div>
								)
							}
							<div className="form-button full-width">
								<Link
									className="button -secondary"
									to={{ pathname: secondaryButtonLinkTo }}
									onClick={onSecondaryButtonClick}
								>
									<TranslationText text={secondaryButtonText} />
								</Link>
							</div>
							{
								!hideCodeEntryControls ? (
									<div className="info-text">
										<p>
											<Trans
												i18nKey={infoText}
												values={infoTextValues}
												components={{ bold: <strong /> }}
											/>
										</p>
										<p>
											<Trans
												i18nKey={resendText}
												components={{ url: <NavLink className="link-button" to="#" onClick={onResend} /> }}
											/>
										</p>
									</div>
								) : null
							}
						</div>
						<footer className="card-footer no-border">
							<div className="footer-text">
								<ConsentLinks />
							</div>
						</footer>
					</div>
				</div>
				<Footer />
			</>
		);
	}
}

export default withTranslation()(VerificationCodeLayout);